import { PlayerIdBool } from "$types"
import Level from "./Level"
import OverlayText from "./OverlayText"
import { PlayerId } from "$types"
import StartBlock from "./StartBlock"

export type StartCallback = (connectedPlayers: PlayerIdBool) => void

export default class Lobby extends Level {
  private _infoText: OverlayText
  private _startBlock: StartBlock
  private _onStart: StartCallback

  constructor(params: {
    x: number,
    y: number,
    levelData: string,
    onStart: StartCallback,
    connectedPlayers: PlayerIdBool
  }) {
    super({
      x: params.x,
      y: params.y,
      levelData: params.levelData,
      activePlayers: {
        1: true,
        2: true,
        3: true,
        4: true
      },
      connectedPlayers: params.connectedPlayers
    })

    this._infoText = new OverlayText({
      text: "Waiting for players...",
      container: this,
      type: "top",
    })

    this._onStart = params.onStart

    this._startBlock = this.children.find((child) => child instanceof StartBlock) as StartBlock
    if (!this._startBlock) {
      throw new Error("Start block not found")
    }
    this._startBlock.onExplode = () => this.fadeOut()

    this._checkIfReady()
  }

  onFadeOutComplete(): void {
    super.onFadeOutComplete()
    this.startGame()
  }

  addPlayer(playerId: PlayerId, active: boolean): void {
    super.addPlayer(playerId, active)
    this.players[playerId]!.invulnerable = true
  }

  setPlayerConnected(playerId: PlayerId, active: boolean): void {
    if (this.players[playerId]?.connected === active) {
      return
    }
    super.setPlayerConnected(playerId, active)
    this._checkIfReady()
  }

  private _checkIfReady(): void {
    const connectedPlayersCount = this.getConnectedPlayers().length
    if (connectedPlayersCount === 0) {
      this._infoText.text = `Waiting for players... ${connectedPlayersCount}/4`
      this._startBlock.destroyable = false
    } else if (connectedPlayersCount === 1) {
      this._infoText.text = `Waiting for more players... ${connectedPlayersCount}/4`
      this._startBlock.destroyable = false
    } else {
      this._infoText.text = "Destroy the red block to start"
      this._startBlock.destroyable = true
    }
  }

  startGame(): void {
    const connectedPlayers = this.getConnectedPlayers()
    if (connectedPlayers.length < 2) return
    this._onStart(
      connectedPlayers.reduce<PlayerIdBool>((acc, { playerId }) => {
        acc[playerId] = true
        return acc
      }, {
        1: false,
        2: false,
        3: false,
        4: false
      })
    )
  }
}
